import React from "react";
import Text from "../../../../../shared/components/Text";
import { formatMoneyNum } from "nemuru-components";
import { SummaryConditionsRow } from "../../shared/components/SummaryConditionsRow";
import { PaymentMode } from "@nemuru-eng/js-api-client";

export const CardConditions = ({ cardAssetDetails }) => {
  if (!cardAssetDetails) return null;

  const { payment_mode, fixed_instalment_amount } = cardAssetDetails;

  return (
    <>
      <SummaryConditionsRow
        title={<Text tId="PAYMENT_MODE" />}
        value={<Text tId={payment_mode ?? PaymentMode.END_OF_MONTH} />}
      />
      {payment_mode === PaymentMode.FIXED_INSTALLMENT && (
        <SummaryConditionsRow
          title={<Text tId="FIXED_INSTALMENT_AMOUNT" />}
          value={<>{formatMoneyNum(fixed_instalment_amount.amount ?? 0)} €</>}
        />
      )}
    </>
  );
};
